<template>
  <i
    :style="{
      'font-size': iconSize
    }" 
  >
    <slot></slot>
  </i>
</template>

<script>
import { colors } from '@/styles/variables.js'

export default {
  name: 'MIcon',

  props: {
    size: {
      type: [String, Number],
      default: '16px'
    },
    color: {
      type: [String],
      default: colors.primary
    }
  },

  computed: {
    iconSize() {
      if (String(this.size).indexOf('px') === -1) {
        return `${this.size}px`
      }
      return this.size
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Icon/MIcon.vue